import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { EmailRecordEntity } from './email-record.entity';
// import { UserEntity } from './user.entity';

@Entity('email_user_status')
@Index(['emailRecordId', 'userId'], { unique: true })
@Index(['userId', 'isRead'])
export class EmailUserStatusEntity extends BaseEntity {
	// Using standard INT id from BaseEntity - no override needed

	@Column({ name: 'fk_email_record__id', type: 'bigint', unsigned: true })
	public emailRecordId!: string;

	@ManyToOne(() => EmailRecordEntity, (record) => record.userStatuses)
	@JoinColumn({ name: 'fk_email_record__id' })
	public emailRecord!: EmailRecordEntity;

	@Column({ name: 'fk_user__id', type: 'int', unsigned: true })
	public userId!: number;

	// TODO PUT THIS BACK WHEN CRM-API IS USING THE CORRECT USER ENTITY
	/*
@ManyToOne(() => UserEntity)
@JoinColumn({ name: 'fk_user__id' })
	public user!: UserEntity;
	 */

	@Column({ name: 'is_read', type: 'boolean', default: false })
	public isRead!: boolean;
}
